import getDoorsFromWallParts from 'components/configurator/services/getDoorsFromWallParts';
import IWall from 'components/interfaces/IWall';
import store from 'store/store';
import { configurationChanged } from 'store/configurationChange/actions';

import {
  isSlidy30,
  isSlidy36,
  isWoodyTypeWall,
} from 'components/configurator/types/glazingWallTypesCheck';

const doWallPreSaveActions = (wall: IWall): IWall => {
  store.dispatch(configurationChanged());

  const getWoodyDoorFrameColor = () => {
    if (isWoodyTypeWall(wall)) {
      return wall.woodyDoorFrameColor;
    }

    return '';
  };

  const getWoodyDoorLeafColor = () => {
    if (isWoodyTypeWall(wall)) {
      return wall.woodyDoorLeafColor;
    }

    return '';
  };

  const getPositionOffset = () => {
    if (isSlidy30(wall)) {
      return 0;
    }

    if (isSlidy36(wall)) {
      return 0;
    }

    return -wall.positionOffset;
  };

  const getDoor = () => {
    if (wall.onlyDoor) {
      const doors = getDoorsFromWallParts(wall);
      return doors[0];
    }
    return {};
  };

  return {
    ...wall,
    ...getDoor(),
    woodyDoorFrameColor: getWoodyDoorFrameColor(),
    woodyDoorLeafColor: getWoodyDoorLeafColor(),
    positionOffset: getPositionOffset(),
  };
};

export default doWallPreSaveActions;
